import {pathReducers} from "./pathReducer";

const rootReducers ={
    pathReducers: pathReducers,
}

export default rootReducers;